import { render, staticRenderFns } from "./IlluGestionCentre.vue?vue&type=template&id=40a02a54&"
import script from "./IlluGestionCentre.vue?vue&type=script&lang=js&"
export * from "./IlluGestionCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports